module.exports = __webpack_public_path__ + "static/media/promo-evrent.bd1f7900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-evrent.jpg
// module id = 327
// module chunks = 0